import { render } from "./CustomFontNewDialog.vue?vue&type=template&id=0d5b34bc"
import script from "./CustomFontNewDialog.vue?vue&type=script&lang=js"
export * from "./CustomFontNewDialog.vue?vue&type=script&lang=js"

import "./CustomFontNewDialog.vue?vue&type=style&index=0&id=0d5b34bc&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__